export default __webpack_public_path__ + "static/media/gplay.ed983bb9.png";